import { render } from "./infoOfWorkers.vue?vue&type=template&id=9e7e6a28"
import script from "./infoOfWorkers.vue?vue&type=script&lang=js"
export * from "./infoOfWorkers.vue?vue&type=script&lang=js"

import "./infoOfWorkers.vue?vue&type=style&index=0&id=9e7e6a28&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__